import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import i18n from '~/i18n'
import CreateAutomationSplash from '~/Common-Objects/Onboarding/splashes/create-automation.png'
import { OnboardingStep } from '~/Common-Objects/Onboarding'

export default function AutomationStep({ isOpen, isComplete, onClick, onCreateAutomation, postHogTag }) {
    return (
        <OnboardingStep
            key='automation'
            title={i18n.t('setup:steps.explore-automations.title')}
            icon={<Icons icon='lightningOutline' color='currentColor' />}
            isOpen={isOpen}
            isComplete={isComplete}
            onClick={onClick}
        >
            <p>{i18n.t('setup:steps.explore-automations.content')}</p>
            <div>
                <Button
                    className='button-primary button-small'
                    iconRight={<Icons icon='arrowRight' />}
                    onClick={(e) => {
                        e.stopPropagation()
                        onCreateAutomation()
                    }}
                    postHogTag={postHogTag}
                >
                    {i18n.t('setup:steps.explore-automations.button-text')}
                </Button>
            </div>
        </OnboardingStep>
    )
}

AutomationStep.splash = <img src={CreateAutomationSplash} alt={i18n.t('setup:steps.explore-automations.title')} />
